import NotificationsPage from './NotificationsPage';

export default NotificationsPage;


// WEBPACK FOOTER //
// ./src/components/NotificationsPage/index.jsx